import { useEvent } from 'effector-react';
import { generateUuid } from '@lib/uuid';
import { useChanges } from '@nx-frontend/shared/hooks/useChangeEvents';
import { getMenuItemsByParentIdFx } from '@nx-frontend/shared/store/feature-menu-tree';
import { MenuType } from '@nx-frontend/shared/types';
import { ChangeEventType } from '@nx-frontend/shared/types';

export interface MenuItemVisibilityChangePayload {
  id: string;
  menuType: MenuType;
  visible: boolean;
  batchId?: string;
}
export const useMenuItemVisibilityChanges = () => {
  const [getMenuItemsByParentId] = useEvent([getMenuItemsByParentIdFx]);
  const setChanges = useChanges();

  return async ({ id, menuType, visible, batchId: preparedBatchId }: MenuItemVisibilityChangePayload) => {
    const items = await getMenuItemsByParentId({ parentId: id, menuType, includeParent: true });
    const batchId = preparedBatchId ?? generateUuid();
    items.forEach((item) => {
      setChanges({
        type: ChangeEventType.CHANGE_MENU_ITEM_VISIBILITY,
        batchId,
        oldValue: { menuType, item: { id: item.id, visible: item.visible } },
        newValue: { menuType, item: { id: item.id, visible: visible } },
      });
      if (item.pageId) {
        setChanges({
          type: ChangeEventType.CHANGE_PAGE_VISIBILITY,
          batchId,
          oldValue: { id: item.pageId, visible: item.visible },
          newValue: { id: item.pageId, visible },
        });
      }
    });
  };
};
